// @ts-nocheck
import React from 'react';
import { BarChart3, TrendingUp, Users, Calendar, AlertTriangle, CheckCircle2, Clock, FileText, Home, PieChart, Briefcase, Settings, Globe, ChevronDown } from 'lucide-react';
import { StandardButton } from '../../components/standard';

interface CyberSweepManagerDashboardProps {
  onViewOperations?: () => void;
}

const CyberSweepManagerDashboard: React.FC<CyberSweepManagerDashboardProps> = ({ onViewOperations }) => {
  // Mock data for manager stats
  const managerStats = {
    totalActive: 247,
    overdueReports: 3,
    readyForReport: 12,
    avgCompletion: 7.2,
    pendingEnrollments: 3,
    lackingRequirements: 3,
    awaitingAssignment: 3,
    pendingChecklists: 4,
    pendingAudits: 5,
    monthlyTrends: {
      completedAudits: [15, 18, 22, 19, 25, 21],
      newEnrollments: [8, 12, 10, 15, 11, 14],
      overdueItems: [2, 1, 3, 2, 1, 3]
    },
    quarterlyBreakdown: {
      Q1: { scheduled: 45, completed: 38, pending: 7 },
      Q2: { scheduled: 52, completed: 48, pending: 4 },
      Q3: { scheduled: 41, completed: 35, pending: 6 },
      Q4: { scheduled: 38, completed: 29, pending: 9 }
    },
    teamPerformance: [
      { auditor: 'Sarah Johnson', completed: 23, pending: 2, avgDays: 6.8 },
      { auditor: 'Mike Chen', completed: 19, pending: 3, avgDays: 7.5 },
      { auditor: 'Lisa Brown', completed: 21, pending: 1, avgDays: 6.2 },
      { auditor: 'David Wilson', completed: 18, pending: 4, avgDays: 8.1 },
      { auditor: 'Emma Davis', completed: 25, pending: 2, avgDays: 5.9 }
    ]
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">CyberSweep Manager Dashboard</h1>
              <p className="text-gray-600 dark:text-gray-400 mt-2">Complete overview of data broker monitoring and audit operations</p>
            </div>
          </div>
        </div>

        {/* Top Menu - Dashboard Navigation */}
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow mb-6">
          <nav className="flex items-center px-4">
            <button
              onClick={onViewOperations}
              className="flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600 transition-colors"
            >
              <Home className="h-4 w-4" />
              Operations Dashboard
            </button>
            <div className="relative group">
              <button
                className="flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 border-transparent text-gray-400 dark:text-gray-500 cursor-not-allowed"
                disabled
              >
                <Briefcase className="h-4 w-4" />
                My Work
              </button>
              <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
                Coming Soon
              </div>
            </div>
            <div className="relative group">
              <button
                className="flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 border-transparent text-gray-400 dark:text-gray-500 cursor-not-allowed"
                disabled
              >
                <Users className="h-4 w-4" />
                Team Dashboard
              </button>
              <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
                Coming Soon
              </div>
            </div>
            <button
              className="flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 border-blue-500 text-blue-600 dark:text-blue-400"
            >
              <BarChart3 className="h-4 w-4" />
              Manager Dashboard
            </button>
            <div className="relative group">
              <button
                className="flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 border-transparent text-gray-400 dark:text-gray-500 cursor-not-allowed"
                disabled
              >
                <PieChart className="h-4 w-4" />
                Reports
              </button>
              <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
                Coming Soon
              </div>
            </div>
            {/* Configuration dropdown */}
            <div className="relative group ml-auto">
              <button
                className="flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600 transition-colors"
              >
                <Settings className="h-4 w-4" />
                Configuration
                <ChevronDown className="h-3 w-3" />
              </button>
              <div className="absolute right-0 top-full mt-1 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50">
                <div className="py-1">
                  <button
                    onClick={() => alert('Coming Soon: Audit Templates')}
                    className="flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
                  >
                    <FileText className="h-4 w-4" />
                    Audit Templates
                  </button>
                  <button
                    onClick={() => alert('Coming Soon: Website Configuration')}
                    className="flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
                  >
                    <Globe className="h-4 w-4" />
                    Website Configuration
                  </button>
                </div>
              </div>
            </div>
          </nav>
        </div>

        {/* Key Metrics Overview */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <Users className="h-8 w-8 text-blue-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Total Active Clients</p>
                <p className="text-2xl font-bold text-gray-900 dark:text-gray-100">{managerStats.totalActive}</p>
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <AlertTriangle className="h-8 w-8 text-red-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Overdue Reports</p>
                <p className="text-2xl font-bold text-red-600">{managerStats.overdueReports}</p>
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <CheckCircle2 className="h-8 w-8 text-green-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Ready for Report</p>
                <p className="text-2xl font-bold text-green-600">{managerStats.readyForReport}</p>
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <Clock className="h-8 w-8 text-purple-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Avg. Completion</p>
                <p className="text-2xl font-bold text-gray-900 dark:text-gray-100">{managerStats.avgCompletion} days</p>
              </div>
            </div>
          </div>
        </div>

        {/* Operational Overview */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 mb-8">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">Pipeline Overview</h3>
            <div className="space-y-3">
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600 dark:text-gray-400">Pending Enrollments</span>
                <span className="font-semibold text-yellow-600">{managerStats.pendingEnrollments}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600 dark:text-gray-400">Lacking Requirements</span>
                <span className="font-semibold text-red-600">{managerStats.lackingRequirements}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600 dark:text-gray-400">Awaiting Assignment</span>
                <span className="font-semibold text-blue-600">{managerStats.awaitingAssignment}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600 dark:text-gray-400">Pending Checklists</span>
                <span className="font-semibold text-purple-600">{managerStats.pendingChecklists}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600 dark:text-gray-400">Pending Audits</span>
                <span className="font-semibold text-indigo-600">{managerStats.pendingAudits}</span>
              </div>
            </div>
          </div>

          {/* Quarterly Performance */}
          <div className="lg:col-span-2 bg-white dark:bg-gray-800 rounded-lg shadow p-6">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4 flex items-center">
              <Calendar className="h-5 w-5 mr-2" />
              Quarterly Performance
            </h3>
            <div className="grid grid-cols-2 gap-4">
              {Object.entries(managerStats.quarterlyBreakdown).map(([quarter, data]) => (
                <div key={quarter} className="border border-gray-200 dark:border-gray-600 rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 dark:text-gray-100 text-center mb-2">{quarter} 2025</h4>
                  <div className="space-y-1 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-600 dark:text-gray-400">Scheduled:</span>
                      <span className="font-medium text-gray-900 dark:text-gray-100">{data.scheduled}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600 dark:text-gray-400">Completed:</span>
                      <span className="font-medium text-green-600">{data.completed}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600 dark:text-gray-400">Pending:</span>
                      <span className="font-medium text-yellow-600">{data.pending}</span>
                    </div>
                    <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2 mt-2">
                      <div
                        className="bg-green-600 h-2 rounded-full"
                        style={{ width: `${(data.completed / data.scheduled) * 100}%` }}
                      ></div>
                    </div>
                    <div className="text-center text-xs text-gray-500 dark:text-gray-400">
                      {Math.round((data.completed / data.scheduled) * 100)}% Complete
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Team Performance */}
          <div className="lg:col-span-2 bg-white dark:bg-gray-800 rounded-lg shadow p-6">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4 flex items-center">
              <BarChart3 className="h-5 w-5 mr-2" />
              Team Performance
            </h3>
            <div className="space-y-3">
              {managerStats.teamPerformance.map((auditor) => (
                <div key={auditor.auditor} className="border border-gray-200 dark:border-gray-600 rounded-lg p-3">
                  <div className="flex justify-between items-center mb-2">
                    <span className="font-medium text-gray-900 dark:text-gray-100">{auditor.auditor}</span>
                    <span className="text-sm text-gray-500 dark:text-gray-400">{auditor.avgDays} avg days</span>
                  </div>
                  <div className="flex justify-between text-sm mb-1">
                    <span className="text-green-600">Completed: {auditor.completed}</span>
                    <span className="text-yellow-600">Pending: {auditor.pending}</span>
                  </div>
                  <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
                    <div
                      className="bg-green-600 h-2 rounded-full"
                      style={{ width: `${(auditor.completed / (auditor.completed + auditor.pending)) * 100}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Trends and Analytics */}
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4 flex items-center">
            <TrendingUp className="h-5 w-5 mr-2" />
            6-Month Trends
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h4 className="font-medium text-gray-900 dark:text-gray-100 mb-3">Completed Audits</h4>
              <div className="space-y-2">
                {managerStats.monthlyTrends.completedAudits.map((value, index) => (
                  <div key={index} className="flex items-center space-x-2">
                    <span className="text-sm text-gray-600 dark:text-gray-400 w-12">Month {index + 1}</span>
                    <div className="flex-1 bg-gray-200 dark:bg-gray-700 rounded-full h-2">
                      <div
                        className="bg-green-600 h-2 rounded-full"
                        style={{ width: `${(value / 30) * 100}%` }}
                      ></div>
                    </div>
                    <span className="text-sm font-medium text-gray-900 dark:text-gray-100 w-8">{value}</span>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-medium text-gray-900 dark:text-gray-100 mb-3">New Enrollments</h4>
              <div className="space-y-2">
                {managerStats.monthlyTrends.newEnrollments.map((value, index) => (
                  <div key={index} className="flex items-center space-x-2">
                    <span className="text-sm text-gray-600 dark:text-gray-400 w-12">Month {index + 1}</span>
                    <div className="flex-1 bg-gray-200 dark:bg-gray-700 rounded-full h-2">
                      <div
                        className="bg-blue-600 h-2 rounded-full"
                        style={{ width: `${(value / 20) * 100}%` }}
                      ></div>
                    </div>
                    <span className="text-sm font-medium text-gray-900 dark:text-gray-100 w-8">{value}</span>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-medium text-gray-900 dark:text-gray-100 mb-3">Overdue Items</h4>
              <div className="space-y-2">
                {managerStats.monthlyTrends.overdueItems.map((value, index) => (
                  <div key={index} className="flex items-center space-x-2">
                    <span className="text-sm text-gray-600 dark:text-gray-400 w-12">Month {index + 1}</span>
                    <div className="flex-1 bg-gray-200 dark:bg-gray-700 rounded-full h-2">
                      <div
                        className="bg-red-600 h-2 rounded-full"
                        style={{ width: `${(value / 5) * 100}%` }}
                      ></div>
                    </div>
                    <span className="text-sm font-medium text-gray-900 dark:text-gray-100 w-8">{value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CyberSweepManagerDashboard;